import React from 'react'

function AddRapprochementForm() {
  return (
    <div>AddRapprochementForm</div>
  )
}

export default AddRapprochementForm